import CloseIcon from '@mui/icons-material/Close';
import { Box, IconButton, Modal, Stack, Typography } from '@mui/material';
import React, { useState } from 'react';

import { ILocalization, ILocalizationToken } from '../../../../../../application/language/ILocalization';
import { inject } from '../../../../../../common/container/inject';
import { IMainLayoutDomainStore } from '../../../store/domain/IMainLayoutDomainStore';
import { PasswordChangeForm } from './PasswordChangeForm';
import { usePasswordForm } from './usePasswordForm';

export const PasswordRequirementsText = () => {
  const [i18n] = useState(inject<ILocalization>(ILocalizationToken));

  return (
    <Stack direction="column" alignItems="start">
      <Typography align="left" variant="body2">
        {i18n.translate('updatePassword.newPasswordRequirementsBase')}
      </Typography>
      <Typography align="left" variant="body2">
        {i18n.translate('updatePassword.passwordRequirements1')}
      </Typography>
      <Typography align="left" variant="body2">
        {i18n.translate('updatePassword.passwordRequirements2')}
      </Typography>
      <Typography align="left" variant="body2">
        {i18n.translate('updatePassword.passwordRequirements3')}
      </Typography>
      <Typography align="left" variant="body2">
        {i18n.translate('updatePassword.passwordRequirements4')}
      </Typography>
    </Stack>
  );
};

export interface PasswordEditModalProps {
  open: boolean;
  handleClose: () => void;
  layoutDomain: IMainLayoutDomainStore;
}

export const PasswordEditModal: React.FC<PasswordEditModalProps> = ({ open, handleClose, layoutDomain }) => {
  const [i18n] = useState(inject<ILocalization>(ILocalizationToken));
  const { handleSubmit, formErrors, setFormErrors } = usePasswordForm({
    handleClose,
    layoutDomain,
    showOldPassword: true,
  });

  const onClose = () => {
    setFormErrors({password: ' ', oldPassword: ' '});
    handleClose()
  }

  return (
    <Modal
      open={open}
      onClose={onClose}
    >
      <Box
        sx={{
          position: 'absolute',
          top: '50%',
          left: '50%',
          transform: 'translate(-50%, -50%)',
          width: 500,
          bgcolor: 'background.paper',
          boxShadow: 24,
          padding: '8px 32px 32px 32px',
          borderRadius: 2,
        }}
      >
        <IconButton onClick={onClose} sx={{ position: 'absolute', top: 8, right: 8, color: 'gray' }}>
          <CloseIcon />
        </IconButton>
        <PasswordChangeForm
          showOldPassword
          title={
            <Typography variant="h5" textAlign="center">
              {i18n.translate('updatePassword.newPasswordTitle')}
            </Typography>
          }
          text={<PasswordRequirementsText />}
          onSubmit={handleSubmit}
          onCancel={onClose}
          errors={formErrors}
          setErrors={setFormErrors}
        />
      </Box>
    </Modal>
  );
};
